<template>
  <span id="share-links">
    <span style="margin-right:6px;">
      <a :href="shareURL" class="twitter-share-button" data-show-count="false">Tweet</a>
    </span>
    &nbsp;
  </span>
</template>

<script>
export default {
  name: 'ShareLinks',
  components: {},

  props: {
    path: { type: String, required: true },
    text: { type: String, required: true },
  },

  data() {
    return {
    };
  },

  mounted() {
    const parent = document.getElementById('share-links');

    // https://developer.twitter.com/en/docs/twitter-for-websites/javascript-api/guides/set-up-twitter-for-websites
    // page must contain snippet, see lib.html load_twitter.
    function loadTwitter() {
      if (window.twttr) {
        window.twttr.ready((twttr) => {
          twttr.widgets.load(parent);
        });
      } else {
        setTimeout(loadTwitter, 2000);
      }
    }
    loadTwitter();

    const linkedJs = document.createElement('script');
    linkedJs.setAttribute('src', 'https://platform.linkedin.com/in.js');
    linkedJs.setAttribute('type', 'text/javascript');
    linkedJs.innerHTML = 'lang: en_US';
    parent.appendChild(linkedJs);

    const linkedShare = document.createElement('script');
    linkedShare.setAttribute('type', 'IN/Share');
    // URL is not set, current URL is used
    // linkedShare.setAttribute('id', 'linked-share');
    // linkedShare.setAttribute('data-url', this.shareURL());
    parent.appendChild(linkedShare);
  },

  computed: {
    shareURL() {
      return `https://twitter.com/intent/tweet?url=https://transformainsights.com/${this.path}&text=${this.text}&via=TransformaTweet`;
    },
  },

  methods: {
  },
};
</script>

<style scoped>
</style>
